import React, { memo } from "react"
import { Link } from "gatsby"

/**
 * S5 — the open door, then the next step (LANDING-PLAN §4).
 *
 * HANDOFF: the service mosaic leaves the reader thinking "none of those
 * disciplines is exactly my situation either". This answers by saying that is
 * the normal case, and asks for the one thing a visitor can do without
 * commitment.
 *
 * This section is what keeps the page honest: it states plainly that the
 * published offers are a subset of the work, so nothing above reads as a
 * company-wide promise (§2.8).
 *
 * Light panel, no photograph. A background image and a dark scrim were tried
 * and dropped: the section is the page's last ask, and a dark band at that
 * point competed with the $deep S2 and the $ink mosaic above it instead of
 * closing quietly. The content is laid across the full width rather than in a
 * single column.
 *
 * CHIPS CARRY NO NEW CLAIM. All three restate something already published
 * above — the Odoo partner status from the hero stats and the mosaic, the
 * warranty with its load-bearing "fixed-scope" qualifier from S4 Q3, and the
 * same-team commitment from the hero line and S4 Q2. Do not add one that is not
 * already stated and true somewhere above.
 */
const CHIPS = [
  "Odoo Ready Partner",
  "30-day warranty on fixed-scope work",
  "Same team from first call to handover",
]

const OpenDoor = () => (
  <section className="hs-door">
    <div className="hs-door__inner" data-reveal>
      <span className="hs-door__eyebrow">If none of that fits</span>
      <h2 className="hs-door__heading">If none of that fits, say so</h2>

      <div className="hs-door__cols">
        <p className="hs-door__lede">
          Your situation may not match a published offer, and that is the normal
          case rather than the exception.
        </p>
        <p className="hs-door__text">
          ERP rollouts, platform modernisation, embedded engineering teams and
          long-running product work are scoped to your situation after we
          understand it.
        </p>
      </div>

      {/* Facts on the left, the ask on the right, both below the divider. The
          CTA closes the section rather than sitting up beside the heading. */}
      <div className="hs-door__foot">
        <ul className="hs-door__chips">
          {CHIPS.map(chip => (
            <li className="hs-door__chip" key={chip}>
              <svg
                className="hs-door__check"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span>{chip}</span>
            </li>
          ))}
        </ul>

        <Link to="/contact" className="hs-door__cta">
          Tell us what you are dealing with &rarr;
        </Link>
      </div>
    </div>
  </section>
)

export default memo(OpenDoor)
